/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SendMailSimulationRecapMutation from '../graphql/mutations/SendMailSimulationRecapMutation.js';

export const useSendMailSimulationRecapMutation = () => {
  return useCommitMutation(SendMailSimulationRecapMutation, {
    dataProp: 'sendMailSimulationRecap_M_simulation_recap'
  });
};

export default useSendMailSimulationRecapMutation;
